import { Card, CardContent, Skeleton, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { Booth } from '../../../interfaces/interfaces';
import { getCountContactSharesOfBooth } from '../../../services/services';

export const BoothTotalContactShare = ({ booth }: { booth: Booth }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [totalShares, setTotalShares] = useState(0);

  async function fetchData() {
    if (!booth) return;

    setLoading(true);
    try {
      const totalShares = await getCountContactSharesOfBooth(booth._id);
      setTotalShares(totalShares);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, [booth]);

  return (
    <Card className="w-full" elevation={0}>
      <CardContent>
        <div className="flex flex-row w-full justify-between">
          <Typography className="font-size: 1rem;line-height: 1.5rem;" color="textSecondary" gutterBottom>
            {t('analytics:event-analytics.total-contact-shares')}
          </Typography>
        </div>
        <div className="flex flex-col w-full">
          {loading && (
            <div className="text-center m-4">
              <Skeleton animation="wave" height={60} width="100%" style={{ marginBottom: 6 }} />
              <Skeleton animation="wave" height={60} width="100%" style={{ marginBottom: 6 }} />
              <Skeleton animation="wave" height={60} width="100%" style={{ marginBottom: 6 }} />
            </div>
          )}
          {!loading && (
            <div className="p-3">
              <Typography variant="h5" component="h2">
                {totalShares}
              </Typography>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
